export default __webpack_public_path__ + "static/media/logoElox.847e219d.png";